import { useQuery } from '@tanstack/react-query';

import SalesService from '@/services/SalesService';

export const SALES_QUERY_KEY = ['sales'];

export function useGetSalesByUserProfileId(userProfileId: string) {
  const { data, isFetching } = useQuery({
    queryKey: SALES_QUERY_KEY.concat([userProfileId]),
    queryFn: () => SalesService.findAllByUserProfileId(userProfileId),
  });

  return {
    sales: data ?? [],
    isLoading: isFetching,
  };
}
